import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output
} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'ls-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  exportAs: 'lsPagination'
})
export class PaginationComponent implements OnInit, OnChanges {
  @Input()
  public totalPages = 0;
  @Input()
  public showPages = 0;
  @Input()
  public showFirstLast = true;
  @Input()
  public showNextPrevious = true;
  @Input()
  public page = 0;
  @Output()
  public update: EventEmitter<number> = new EventEmitter<number>();
  public currentPage: number;
  public pages: Array<number> = [];

  public ngOnInit(): void {
    this.goToPage(1);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['totalPages'] &&
        changes['totalPages'].currentValue !==
          changes['totalPages'].previousValue) ||
      (changes['showPages'] &&
        changes['showPages'].currentValue !==
          changes['showPages'].previousValue)
    ) {
      this.currentPage = 1;
      this.pages = this.getPageRange(1, this.totalPages);
    }
  }

  public goToPage(page: number, emitEvent: boolean = true): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.pages = this.getPageRange(page, this.totalPages);
      if (emitEvent) {
        this.update.emit(page);
      }
    }
  }

  public isFirstPage(page: number): boolean {
    return page === 1;
  }

  public isLastPage(page: number): boolean {
    return page >= this.totalPages;
  }

  private getPageRange(currentPage: number, totalPages: number): Array<number> {
    const startOffset: number = Math.floor(this.showPages / 2);
    let start: number = Math.max(currentPage - startOffset, 1);
    const end: number = Math.min(start + this.showPages, totalPages + 1);
    if (end - start < this.showPages && totalPages >= this.showPages) {
      start -= this.showPages - (end - start);
    } else if (totalPages < this.showPages) {
      start = 1;
    }
    return _.range(start, end);
  }
}
